"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-337665ee"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { key: 0 };
var _hoisted_2 = {
    key: 1,
    style: { "max-width": "300px" }
};
var _hoisted_3 = { style: { "max-width": "450px" } };
var _hoisted_4 = { key: 2 };
var _hoisted_5 = { key: 3 };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("p", { class: "text" }, " 系统视图切换，请稍候... ", -1); });
var _hoisted_7 = {
    key: 0,
    class: "pagination-box"
};
var _hoisted_8 = { class: "table-edit-box" };
var _hoisted_9 = { class: "col-checkbox-box" };
var _hoisted_10 = { class: "confirm-btn" };
var vue_3 = require("vue");
// 定义父组件传过来的值
exports.default = (0, vue_1.defineComponent)({
    __name: 'TableUnit',
    props: {
        columns: {
            type: Array,
            default: function () { return []; },
        },
        list: {
            //表格数据
            type: Array,
            default: function () { return []; },
        },
        loading: {
            //是否使用loading
            type: Boolean,
            default: false,
        },
        // 换行变色
        stripe: {
            type: Boolean,
            default: true,
        },
        isSelection: {
            //是否显示多选框
            type: Boolean,
            default: false,
        },
        // 表格高度
        height: {
            type: [Number, String],
            default: window.innerHeight - 240,
        },
        // 是否需要序号
        isIndex: {
            type: Boolean,
            default: false,
        },
        // 分页组件
        currentPage: {
            //当前页码
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: 0,
        },
        // 是否显示分页
        isShowPatination: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['linkFun', 'handleSelectionChange', 'handleSizeChange', 'handleCurrentChange'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var drawer = (0, vue_3.ref)(false);
        var checkedCols = (0, vue_3.ref)([]);
        var cols = (0, vue_3.ref)([]);
        props.columns.forEach(function (item) {
            checkedCols.value.push(item.dataIndex);
            cols.value.push(item);
        });
        // console.log(cols.value);
        // console.log(checkedCols.value);
        var confirmCol = function () {
            var arr = [];
            props.columns.forEach(function (item) {
                if (checkedCols.value.includes(item.dataIndex)) {
                    arr.push(item);
                }
            });
            cols.value = arr;
            drawer.value = false;
        };
        var reSet = function () {
            if (props.columns.length === checkedCols.value.length) {
                drawer.value = false;
                return;
            }
            var checkArr = [];
            var arr = [];
            props.columns.forEach(function (item) {
                checkArr.push(item.dataIndex);
                arr.push(item);
            });
            checkedCols.value = checkArr;
            cols.value = arr;
            drawer.value = false;
        };
        // 定义子组件向父组件传值/事件
        var linkFun = function (val) {
            emit('linkFun', val);
        };
        var handleSelectionChange = function (val) {
            emit('handleSelectionChange', val);
        };
        var indexMethod = function (index) {
            return index + 1;
        };
        var handleSizeChange = function (val) {
            //改变数据条目数量
            emit('handleSizeChange', val);
        };
        var handleCurrentChange = function (val) {
            //改变页码
            emit('handleCurrentChange', val);
        };
        var isReload = (0, vue_3.ref)(true);
        var tableHeight = props.height;
        (0, vue_3.onMounted)(function () {
            if (!props.height) {
                tableHeight = window.innerHeight - 240;
            }
        });
        var timer = null;
        var previousHeight = 0;
        var onResize = function () {
            var currentHeight = window.innerHeight;
            if (timer || currentHeight === previousHeight)
                return;
            timer = setTimeout(function () {
                isReload.value = false;
                var fullScreenTimer = null;
                fullScreenTimer = setTimeout(function () {
                    tableHeight = window.innerHeight - 240;
                    previousHeight = currentHeight;
                    isReload.value = true;
                    if (fullScreenTimer) {
                        clearTimeout(fullScreenTimer);
                    }
                }, 1000);
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
            }, 500);
        };
        window.addEventListener("resize", onResize);
        (0, vue_3.onUnmounted)(function () {
            window.removeEventListener("resize", onResize);
        });
        return function (_ctx, _cache) {
            var _component_el_table_column = (0, vue_2.resolveComponent)("el-table-column");
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_el_tooltip = (0, vue_2.resolveComponent)("el-tooltip");
            var _component_el_tag = (0, vue_2.resolveComponent)("el-tag");
            var _component_el_table = (0, vue_2.resolveComponent)("el-table");
            var _component_Loading = (0, vue_2.resolveComponent)("Loading");
            var _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            var _component_el_pagination = (0, vue_2.resolveComponent)("el-pagination");
            var _component_el_checkbox = (0, vue_2.resolveComponent)("el-checkbox");
            var _component_el_checkbox_group = (0, vue_2.resolveComponent)("el-checkbox-group");
            var _component_el_drawer = (0, vue_2.resolveComponent)("el-drawer");
            var _directive_loading = (0, vue_2.resolveDirective)("loading");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", null, [
                    ((0, vue_2.unref)(isReload))
                        ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_table, {
                            key: 0,
                            stripe: __props.stripe,
                            height: (0, vue_2.unref)(tableHeight),
                            onSelectionChange: handleSelectionChange,
                            data: __props.list,
                            border: true,
                            fit: ""
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (__props.isSelection)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_table_column, {
                                        key: 0,
                                        align: "center",
                                        type: "selection",
                                        width: "50"
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (__props.isIndex)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_table_column, {
                                        key: 1,
                                        type: "index",
                                        width: "50",
                                        label: "序号",
                                        align: "center",
                                        index: indexMethod
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(cols), function (item, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_table_column, {
                                        key: index,
                                        fixed: item.fixed,
                                        align: item.align,
                                        label: item.title,
                                        width: item.width
                                    }, {
                                        default: (0, vue_2.withCtx)(function (_a) {
                                            var row = _a.row;
                                            return [
                                                (item.dataIndex !== 'operate')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_1, [
                                                        (item.isLink)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                                                key: 0,
                                                                link: "",
                                                                type: "primary",
                                                                onClick: function ($event) { return (linkFun(row)); }
                                                            }, {
                                                                default: (0, vue_2.withCtx)(function () { return [
                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]), 1)
                                                                ]; }),
                                                                _: 2
                                                            }, 1032, ["onClick"]))
                                                            : (item.overflow)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                                                    (0, vue_2.createVNode)(_component_el_tooltip, {
                                                                        effect: "light",
                                                                        placement: "top"
                                                                    }, {
                                                                        content: (0, vue_2.withCtx)(function () { return [
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(row[item.dataIndex]), 1)
                                                                        ]; }),
                                                                        default: (0, vue_2.withCtx)(function () { return [
                                                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(row[item.dataIndex]), 1)
                                                                        ]; }),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]))
                                                                : (item.isTag)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, [
                                                                        (row[item.dataIndex] && row[item.dataIndex]['code'] === 1)
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_tag, {
                                                                                key: 0,
                                                                                type: "success"
                                                                            }, {
                                                                                default: (0, vue_2.withCtx)(function () { return [
                                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]['value']), 1)
                                                                                ]; }),
                                                                                _: 2
                                                                            }, 1024))
                                                                            : (row[item.dataIndex] && row[item.dataIndex]['code'] === 2)
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_tag, {
                                                                                    key: 1,
                                                                                    type: "warning"
                                                                                }, {
                                                                                    default: (0, vue_2.withCtx)(function () { return [
                                                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]['value']), 1)
                                                                                    ]; }),
                                                                                    _: 2
                                                                                }, 1024))
                                                                                : (row[item.dataIndex] && row[item.dataIndex]['code'] === 3)
                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_tag, {
                                                                                        key: 2,
                                                                                        type: "danger"
                                                                                    }, {
                                                                                        default: (0, vue_2.withCtx)(function () { return [
                                                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]['value']), 1)
                                                                                        ]; }),
                                                                                        _: 2
                                                                                    }, 1024))
                                                                                    : (row[item.dataIndex] && row[item.dataIndex]['code'] === 4)
                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_tag, {
                                                                                            key: 3,
                                                                                            type: "info"
                                                                                        }, {
                                                                                            default: (0, vue_2.withCtx)(function () { return [
                                                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]['value']), 1)
                                                                                            ]; }),
                                                                                            _: 2
                                                                                        }, 1024))
                                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                        (0, vue_2.createVNode)(_component_el_tag, null, {
                                                                            default: (0, vue_2.withCtx)(function () { return [
                                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(row[item.dataIndex]['value']), 1)
                                                                            ]; }),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ]))
                                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_5, (0, vue_2.toDisplayString)(row[item.dataIndex]), 1))
                                                    ]))
                                                    : (0, vue_2.renderSlot)(_ctx.$slots, "default", {
                                                        key: 1,
                                                        record: row
                                                    })
                                            ];
                                        }),
                                        _: 2
                                    }, 1032, ["fixed", "align", "label", "width"]));
                                }), 128))
                            ]; }),
                            _: 3
                        }, 8, ["stripe", "height", "data"])), [
                            [_directive_loading, __props.loading]
                        ])
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 1,
                            style: (0, vue_2.normalizeStyle)("height: ".concat((0, vue_2.unref)(tableHeight), "px;")),
                            class: "toggleTableView"
                        }, [
                            (0, vue_2.createVNode)(_component_el_icon, { class: "icon" }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_Loading)
                                ]; }),
                                _: 1
                            }),
                            _hoisted_6
                        ], 4))
                ]),
                (__props.isShowPatination)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                        (0, vue_2.createVNode)(_component_el_pagination, {
                            background: "",
                            disabled: __props.total === 0 ? true : false,
                            onSizeChange: handleSizeChange,
                            onCurrentChange: handleCurrentChange,
                            "current-page": __props.currentPage,
                            "page-sizes": [10, 20, 30, 40, 50],
                            "page-size": 10,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: __props.total
                        }, null, 8, ["disabled", "current-page", "total"]),
                        (0, vue_2.createVNode)(_component_el_button, {
                            onClick: _cache[0] || (_cache[0] = function ($event) { return ((0, vue_2.isRef)(drawer) //@ts-ignore
                                ? drawer.value = true : drawer = true); }),
                            class: "table-order",
                            type: "primary",
                            icon: "Operation",
                            circle: ""
                        })
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(_component_el_drawer, {
                    style: { "padding": "0px" },
                    size: "20%",
                    modelValue: (0, vue_2.unref)(drawer),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((0, vue_2.isRef)(drawer) ? (drawer).value = $event : drawer = $event); }),
                    title: "表格栏编辑"
                }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createVNode)(_component_el_checkbox_group, {
                                    modelValue: (0, vue_2.unref)(checkedCols),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((0, vue_2.isRef)(checkedCols) ? (checkedCols).value = $event : checkedCols = $event); }),
                                    min: 5
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.columns, function (item) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                class: "col-checkbox",
                                                key: item.dataIndex
                                            }, [
                                                (0, vue_2.createVNode)(_component_el_checkbox, {
                                                    label: item.dataIndex,
                                                    disabled: item.dataIndex === 'operate'
                                                }, {
                                                    default: (0, vue_2.withCtx)(function () { return [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.title), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["label", "disabled"])
                                            ]));
                                        }), 128))
                                    ]; }),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                (0, vue_2.createVNode)(_component_el_button, {
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return ((0, vue_2.isRef)(drawer) //@ts-ignore
                                        ? drawer.value = false : drawer = false); })
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" 关 闭 ")
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_button, {
                                    type: "success",
                                    onClick: reSet
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" 还 原 ")
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_button, {
                                    onClick: confirmCol,
                                    type: "primary"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" 确 认 ")
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ])
                    ]; }),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
